import React from "react";
import "../Footer/footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      Copyright &#169; 2023 Nalatech.id. All right received.
    </footer>
  );
};

export default Footer;
